import {post} from "../utils";

export default host => id => post(`${host}/contentCreations/${id}/trackView`)